import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../app';
import Component from '../../common/Component';
import classList from '../../common/utils/classList';
import ItemList from '../../common/utils/ItemList';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import { prepareSkipLinks } from '../../common/utils/a11y';
export default class PageStructure extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "content", void 0);
  }
  view(vnode) {
    const {
      className
    } = vnode.attrs;
    this.content = vnode.children;
    return m("div", {
      className: classList('Page', className)
    }, this.rootItems().toArray());
  }
  rootItems() {
    const items = new ItemList();
    items.add('pane', this.providedPane(), 100);
    items.add('main', this.main(), 10);
    return items;
  }
  mainItems() {
    const items = new ItemList();
    items.add('hero', this.providedHero(), 100);
    items.add('container', this.container(), 10);
    return items;
  }
  loadingItems() {
    const items = new ItemList();
    items.add('spinner', m(LoadingIndicator, {
      display: "block"
    }), 100);
    return items;
  }
  main() {
    return m("div", {
      className: "Page-main",
      id: "page-main"
    }, this.attrs.loading ? this.loadingItems().toArray() : this.mainItems().toArray());
  }
  containerItems() {
    const items = new ItemList();
    items.add('sidebar', this.sidebar(), 100);
    items.add('content', this.providedContent(), 10);
    return items;
  }
  container() {
    return m("div", {
      className: "Page-container container"
    }, this.containerItems().toArray());
  }
  sidebarItems() {
    const items = new ItemList();
    items.add('skipToMainContent', m("a", {
      href: "#main-content",
      className: "sr-only sr-only-focusable-custom",
      oncreate: () => prepareSkipLinks()
    }, app.translator.trans('core.forum.index.skip_to_main_content')), 200);
    items.add('sidebar', this.attrs.sidebar && this.attrs.sidebar() || null, 100);
    return items;
  }
  sidebar() {
    return m("div", {
      className: "Page-sidebar"
    }, this.sidebarItems().toArray());
  }
  providedPane() {
    return m("div", {
      className: "Page-pane"
    }, this.attrs.pane && this.attrs.pane() || null);
  }
  providedHero() {
    return m("div", {
      className: "Page-hero"
    }, this.attrs.hero && this.attrs.hero() || null);
  }
  providedContent() {
    return m("div", {
      className: "Page-content",
      id: "main-content"
    }, this.content);
  }
}
flarum.reg.add('core', 'forum/components/PageStructure', PageStructure);